export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5281.13905b77.jpg";